import { ShowCaseActionType } from "./enums/showCaseActionType";
import { CreditViewData } from "./creditViewData";
import { CreditCalcData } from "./creditCalcData";
import urlFilter from "../filters/url.filter";

/** Класс для данных о странице витрины */

export class ShowcaseCreditData {

    /**
     * Заголовок элемента витрины.
     */
    public Caption: string = "";

    public Id: number = 0;

    /**
     * URL каритнки элемента витрины.
     */
    public Image: string = "";

    /**
     * URL каритнки для адаптива.
     */
    public ImageMp: string = "";

    /**
     * Тип действия элемента витрины.
     */
    public ActionType: ShowCaseActionType = ShowCaseActionType.None;

    /**
     * URL для действия элемента витрины.
     */
    public ActionLink: string = "";

    public CreditView: CreditViewData = new CreditViewData({});

    public CalcView: CreditCalcData = new CreditCalcData({});

    public RespondentCode: string = "";

    public RespondentCodeRequest: string = "";

    public CreditType: string = "";

    constructor(creditView: any, creditData: any) {
        this.Caption = creditView.caption ?? "";
        this.Id = creditData.Id ?? 0;
        this.Image = urlFilter(creditData.Data.view.imageWeb ?? '');
        this.ImageMp = urlFilter(creditData.Data.view.image ?? '');
        this.ActionType = (creditView.actionType as ShowCaseActionType) ?? ShowCaseActionType.None;
        this.ActionLink = creditView.actionLink ?? "";
        this.CreditView = new CreditViewData(creditData.Data.view);
        this.CalcView = new CreditCalcData(creditData.Data.calc);
        this.RespondentCode = creditData.Data.respondentCode ?? "";
        this.RespondentCodeRequest = creditData.Data.respondentCodeRequest ?? "";
        this.CreditType = creditData.Data.creditType ?? "";
    }

}